import { ButtonsOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../catalog/config/component.config';
import { NCmsNewsletterBlock } from './cms-newsletter-block.interface';

export const CMS_NEWSLETTER_BLOCK_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsNewsletterBlock.BLOCK_ID,
    block: {
        url: NCmsNewsletterBlock.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Subscribe newsletter block',
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Title',
            default: 'Sign up to our newsletter'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image'
        },
        <NICmsContentField.IField>{
            key: 'bgColor',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Background Color'
        },
        <NICmsContentField.ITextField>{
            key: 'ctaText',
            type: NICmsContentField.EFieldType.text,
            title: 'Button Text',
            default: 'Subscribe me'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ctaStyle',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
